const lightTheme = {
    background: "#f9f9f9",
    secondoryBackground: "#0c0c0c",
    textPrimary: "#333",
    textSecondary: "#555",
    text:"#999",
    border: "#e0e0e0",
    buttonBackground: "#0c0c0c",
    buttonText: "#fff",
    navBackground: "rgba(0, 0, 0, 0.1)",
    navText: "#808080",
    navActive: "#fcfcfc",
    linkHover: "#000",
    error: "#d9534f",
    success: "#5cb85c",
    cardBackground: "#fff",
    checkborder:"black",
    checkbackground:"#ccc"
  };
  
  const darkTheme = {
    background: "#1c1c1c",
    textPrimary: "#f9f9f9",
    textSecondary: "#ccc",
    text:"#999",
    border: "#333",
    buttonBackground: "#fcfcfc",
    buttonText: "#0c0c0c",
    navBackground: "rgba(255, 255, 255, 0.1)",
    navText: "#999",
    navActive: "#fff",
    linkHover: "#ddd",
    error: "#d9534f",
    success: "#5cb85c",
    cardBackground: "#2c2c2c",
    checkborder:"#fff",
    checkbackground:"#333",
  };
  
  export { lightTheme, darkTheme };
  